export interface FerryVehicle {
    Type: FerryVehicleType;
    Description: string;
    LicensePlate: string | null;
}

export enum FerryVehicleType {
    Vehicle6mLong = 'Vehicle6mLong',
    MotorBike = 'MotorBike',
    None = 'None',
    Bicycle = 'Bicycle',
    MiniBus4mHigh6mLong = 'MiniBus4mHigh6mLong',
    Vehicle4m70cmLong = 'Vehicle4m70cmLong',
    MultiPurposeVehicle = 'MultiPurposeVehicle',
    MiniBus8mLong = 'MiniBus8mLong',
}
